module.exports = __webpack_public_path__ + "img/logoFantini-nero.ede53455.png";